/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';

// UI lib components
import { Text, Button } from '@mantine/core';

// Store
import dialogStoreVar from '@features/Dialog/store/dialogStore';

// Types
import { ButtonCreateFolderProps } from './types';

// Assets
import { IconFolderPlus as IconCreateFolder } from '@tabler/icons-react';

// Style
import { palette } from '@ui-kit/colors';
import { FONT_WEIGHT } from '@ui-kit/fonts';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function ButtonCreateFolder({ ...props }: ButtonCreateFolderProps) {
  /* ********************************** HOOKS ********************************* */

  // Store
  const dialogStore = useReactiveVar(dialogStoreVar);

  // Localization
  const { t } = useTranslation('Resource');

  /* ******************************** RENDERING ******************************* */

  return (
    <Button
      variant="light"
      size="sm"
      radius="xs"
      px="sm"
      flex={1}
      color="blackroomGray"
      styles={{ label: { overflow: 'visible' } }}
      leftSection={
        <IconCreateFolder
          size={18}
          color={props.disabled ? undefined : palette.blackroomDarkGray4}
        />
      }
      onClick={function cb() {
        dialogStore?.invokeDialog?.('dialog-resource-create-folder', {
          modalProps: {
            title: t('DialogResourceCreateFolder.title'),
          },
        });
      }}
      {...props}
    >
      <Text
        fw={FONT_WEIGHT.bold}
        c={props.disabled ? undefined : palette.blackroomDarkGray4}
        truncate={false}
      >
        {t('ResourcePane.toolbar.createFolder')}
      </Text>
    </Button>
  );
}

export default ButtonCreateFolder;
